import updateItemLanguageAction from '../actions/updateItemLanguageAction';
import { lazyGetItemProperties } from 'owa-get-item-manager';
import { GetItemManagerFeatureIds } from 'owa-mail-smart-pill-features';
import { ClientItem } from 'owa-mail-store';
import { SmartPillPreRunner } from 'owa-smart-pill';

export default function createLanguagePreRunner(item: ClientItem): SmartPillPreRunner {
    return {
        preRun: async () => {
            const getItemProperties = await lazyGetItemProperties.import();
            const itemWithProperty: ClientItem = (await getItemProperties(
                item.ItemId.Id,
                GetItemManagerFeatureIds.LanguageAndLocale
            )) as ClientItem;

            if (itemWithProperty && !itemWithProperty.stampedLanguage) {
                // After merging properties, log the message language if needed.
                updateItemLanguageAction(itemWithProperty);
            }
        },
        getName: () => {
            return 'LanguagePreRunner';
        },
    };
}
